/**
 * Product Families Reducer
 */

import { ProductFamily } from '../../common/models/product-family.model';
import {
  SET_PRODUCT_FAMILIES,
  SET_PRODUCT_FAMILIES_LOADING,
  SET_PRODUCT_FAMILIES_ERROR,
  SET_ACTIVE_FAMILY,
  ADD_PRODUCT_FAMILY,
  UPDATE_PRODUCT_FAMILY,
  DELETE_PRODUCT_FAMILY,
  SET_SELECTED_FAMILY_FILTER,
} from './productFamiliesActionTypes';

export interface ProductFamiliesState {
  /** List of all product families (or vendor's enabled families) */
  families: ProductFamily[];
  /** Currently active/selected family for editing */
  activeFamily: ProductFamily | null;
  /** Loading state for async operations */
  loading: boolean;
  /** Error message if any */
  error: string | null;
  /** Selected family ID for filtering products */
  selectedFamilyFilter: string | null;
}

const initialState: ProductFamiliesState = {
  families: [],
  activeFamily: null,
  loading: false,
  error: null,
  selectedFamilyFilter: null,
};

interface ProductFamiliesAction {
  type: string;
  payload?: any;
}

const productFamiliesReducer = (
  state = initialState,
  action: ProductFamiliesAction
): ProductFamiliesState => {
  switch (action.type) {
    case SET_PRODUCT_FAMILIES:
      return {
        ...state,
        families: action.payload,
        loading: false,
        error: null,
      };

    case SET_PRODUCT_FAMILIES_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case SET_PRODUCT_FAMILIES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case SET_ACTIVE_FAMILY:
      return {
        ...state,
        activeFamily: action.payload,
      };

    case ADD_PRODUCT_FAMILY:
      return {
        ...state,
        families: [...state.families, action.payload],
      };

    case UPDATE_PRODUCT_FAMILY:
      return {
        ...state,
        families: state.families.map(family =>
          family._id === action.payload._id ? action.payload : family
        ),
        // Also update activeFamily if it's the same one
        activeFamily:
          state.activeFamily?._id === action.payload._id
            ? action.payload
            : state.activeFamily,
      };

    case DELETE_PRODUCT_FAMILY:
      return {
        ...state,
        families: state.families.filter(family => family._id !== action.payload),
        // Clear activeFamily if it was deleted
        activeFamily:
          state.activeFamily?._id === action.payload ? null : state.activeFamily,
        // Clear filter if the filtered family was deleted
        selectedFamilyFilter:
          state.selectedFamilyFilter === action.payload
            ? null
            : state.selectedFamilyFilter,
      };

    case SET_SELECTED_FAMILY_FILTER:
      return {
        ...state,
        selectedFamilyFilter: action.payload,
      };

    case 'RESET':
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default productFamiliesReducer;
